import { WORKFLOW_MESSAGE_TYPE_EMAIL } from 'Api/beAutomationApi'
import { notifyParent } from 'mailup-react-helpers'
import {
  ACTION_BUTTON_TYPE_DELETE,
  ACTION_BUTTON_TYPE_EDIT,
  ButtonAction,
  LINK_VARIANT_HIGHLIGHT,
  TEXT_VARIANT_SMALL_LIGHT,
  TooltipUtils,
  TruncateAndTooltip
} from 'mailup-web-components'
import { workflowEmailMessageSubjectSelector } from 'Pages/Workflow/recoil/state/data'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import * as S from './WorkflowBuilder.styles'

// import { modalEmailMessagesState } from 'Hooks/useModalEmailMessages/useModalEmailMessages'

const EmailItem = ({
  draggableId,
  idMessage,
  onDelete,
  onEdit,
  subject,
  currentDragItem,
  canDelete
}) => {
  const intl = useIntl()
  const storedSubject = useRecoilValue(
    workflowEmailMessageSubjectSelector(idMessage)
  )

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  const handleSubjectClick = () => {
    notifyParent('openPreviewMainFrame', [idMessage])
  }

  const handleDelete = () => {
    onDelete(draggableId)
  }

  const handleEdit = () => {
    onEdit(draggableId, WORKFLOW_MESSAGE_TYPE_EMAIL)
  }

  return (
    <S.InnerItem>
      {currentDragItem !== draggableId && <S.ItemHorizontalLine />}
      <S.ItemCircle>
        {currentDragItem !== draggableId && <S.Circle />}
      </S.ItemCircle>
      <S.WorkflowBuilderItem>
        <S.ItemLeft>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.DragElementMessage'
          })}
        </S.ItemLeft>

        <S.ItemRight>
          {idMessage > 0 ? (
            <>
              <S.LinkBold
                variant={LINK_VARIANT_HIGHLIGHT}
                firstOf2Line
                onClick={handleSubjectClick}
              >
                <TruncateAndTooltip text={subject || storedSubject} />
              </S.LinkBold>
              <S.StyledId variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {idMessage}
              </S.StyledId>
            </>
          ) : (
            <S.LinkBold
              variant={LINK_VARIANT_HIGHLIGHT}
              verticalCenter
              onClick={handleEdit}
            >
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.DragElementChoseMessage'
              })}
            </S.LinkBold>
          )}
        </S.ItemRight>
        <S.ItemActions withGhostActions>
          <div className='ghost'>
            {idMessage > 0 && (
              <ButtonAction
                type={ACTION_BUTTON_TYPE_EDIT}
                onClick={handleEdit}
              />
            )}
            {canDelete && (
              <ButtonAction
                type={ACTION_BUTTON_TYPE_DELETE}
                onClick={handleDelete}
              />
            )}
          </div>
        </S.ItemActions>
      </S.WorkflowBuilderItem>
    </S.InnerItem>
  )
}

/*

<S.ItemActions withGhostActions>
  <div className='ghost'>
    {item.type !== 'wait' && item.IdMessage ? (
      <ButtonAction
        type={ACTION_BUTTON_TYPE_EDIT}
        onClick={() => null}
      />
    ) : null}
    <ButtonAction
      type={ACTION_BUTTON_TYPE_CANCEL}
      onClick={() => handleDelete(item.id)}
    />
  </div>
</S.ItemActions>

*/

EmailItem.propTypes = {
  idMessage: PropTypes.number,
  draggableId: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  subject: PropTypes.string,
  currentDragItem: PropTypes.string,
  canDelete: PropTypes.bool
}

/*
Id	integer($int32)
IdWorkflow	integer($int32)
IdMessage	integer($int32)
WaitType	integer($int32)
Value	integer($int32)
ValueType	integer($int32)
MessageType	integer($int32)
*/
export default EmailItem
